export default "__VITE_ASSET__CNSCki$O__"